import styled from 'styled-components';
import { Link } from '@zillow/zrs-comet';

export const StyledLink = styled(Link)`
    && {
        font-weight: 400;
    }
`;
